import React from 'react';
import Tooltip from '@creditflowresearch/uilib/Tooltip';
import styles from '@/creditflowresearch/ui/components/league/LeagueTablePage/leagueTablePage.module.scss';

interface ICellProps {
  cellData: string,
}

export const dealCountCellCallback = (cellProps: ICellProps) => (
  <Tooltip content="Deal Count">
    { cellProps.cellData }
  </Tooltip>
);

export const typeCellCallback = (cellProps: ICellProps) => (
  <span className={ styles.typeCell }>
    { cellProps.cellData === 'underwriter' ? 'Underwriter' : 'Rating Agency' }
  </span>
);
